import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LoadingSpinners from '@/components/r3f/LoadingSpinners/LoadingSpinners';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { createCanvasR3fComponents, useGetActiveSceneScreenContentId, useGetScreenRelativeDomCanvasAspectRatio } from '../../../../../utils';
import { getAnchorGroupPrositionDict } from '../../../r3f-components/utils/screen-relative';
const AnchorGroups = () => {
    const activeScreenContentId = useGetActiveSceneScreenContentId();
    const componentsById = useSelector((state) => state.contentReducer.contentDoc.componentsById);
    const screenRelativeCanvasAspectRatio = useGetScreenRelativeDomCanvasAspectRatio();
    const anchorGroupPositionDict = getAnchorGroupPrositionDict(screenRelativeCanvasAspectRatio);
    const hiddenEntities = Object.keys(componentsById).filter((entityId) => !!componentsById[entityId].isHidden);
    const activeScreenContent = componentsById[activeScreenContentId];
    const spinnerData = useSelector((state) => state.userReducer.spinnerData);
    const anchorGroups = activeScreenContent.children.map((id) => {
        const anchorGroup = componentsById[id];
        const anchorR3fComponents = createCanvasR3fComponents({
            ids: anchorGroup.children,
            hiddenEntityIds: hiddenEntities,
            componentsById,
        });
        return (_jsxs("group", { name: anchorGroup.anchorPositionType, scale: 1, position: anchorGroupPositionDict[anchorGroup.anchorPositionType], children: [anchorR3fComponents, anchorGroup.anchorPositionType === 'center' && _jsx(LoadingSpinners, { isScreenRelativeSpinners: true, spinnerDataArray: Object.values(spinnerData) })] }, anchorGroup.anchorPositionType));
    });
    return _jsx(_Fragment, { children: anchorGroups });
};
export default memo(AnchorGroups);
